import { Head } from '@inertiajs/react'
import { Box } from '@mui/material'
import { ProfileTab, ProspectMainLayout } from '../../components'

interface ProfileData {
    // Basic Info
    first_name: string;
    last_initial: string;
    profile_pic_url: string | null;
    short_intro: string;

    // Employment
    occupation: string;
    employer: string;

    // Rental Preferences
    budget: string;
    bedrooms: string;
    bathrooms: string;
    desired_move_in: string;
    lease_length: string;
    rental_type?: string;
    tour_preference?: string;
    occupants: string;
    neighborhoods: string;
    additionalInfo: string;

    // Pet and housing info
    housingVoucher: string;
    numDogs: string;
    numCats: string;
}

interface Props {
    profileData: ProfileData;
}

export default function ProfilePage({ profileData }: Props) {
    return (
        <>
        { console.log(profileData) }
            <Head title="Profile - HeyyProperty" />

            <ProspectMainLayout
                activeTab="profile"
            >
                <Box sx={{ py: 1 }}>
                    <ProfileTab profileData={profileData} />
                </Box>
            </ProspectMainLayout>
        </>
    )
}
